import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-news',
  templateUrl: './add-news.component.html',
  styleUrls: ['./add-news.component.scss']
})
export class AddNewsComponent implements OnInit {

      public pages  : any
  public tempData = [];
  public totalItems = 0;
  previewUrl: any;

imagePreviews: string[] = [];
formData: any = {
  title: '',
  content: '',
    main_image: '',
  images: [] as File[] | null

}; 
  InvestorsId: any;
 
  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,
    public _translateService: TranslateService
  ) {}

    ngOnInit(): void {
     this.getTags();
     this. getInvestorsId(); 

    }
 
    // Handle PDF selection
onPdfSelected(event: any): void {
  if (event.target.files.length > 0) {
    this.formData.pdf = event.target.files[0];
  }
}

getTags() {
  this.apisService.contractsType().subscribe({
    next: (response: any) => {
      this.pages = response.data || [];
      this.totalItems = this.pages.length;
      console.log('pages:', this.pages);
    },
    error: (error: any) => {
      console.error('Error fetching contract types:', error);
    }
  });
}
onImagesSelected(event: any): void {

  const files: FileList = event.target.files;

  if (!files || files.length === 0) {
    this.formData.images = null;
    return;
  }

  this.formData.images = [];
  this.imagePreviews = [];

  Array.from(files).forEach((file: File) => {
    this.formData.images!.push(file);

    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.imagePreviews.push(e.target.result);
    };
    reader.readAsDataURL(file);
  });
}
removeImage(index: number): void {
  this.formData.images?.splice(index, 1);
  this.imagePreviews.splice(index, 1);

  if (this.formData.images?.length === 0) {
    this.formData.images = null;
  }
}
onFileSelected(event: any): void {
  console.log('File selected:', event); // للتأكد من تشغيل الدالة
  
  if (event.target.files.length > 0) {
    const file = event.target.files[0];
    this.formData.main_image = file;
    
    // عرض معاينة الصورة الجديدة
    this.previewLogo(file);
  }
}

// دالة خاصة لعرض معاينة الصورة
previewLogo(file: File): void {
  const reader = new FileReader();
  
  reader.onload = (e: any) => {
    console.log('File preview loaded'); // للتأكد من اكتمال التحميل
    this.previewUrl = e.target.result;
  };
  
  reader.onerror = (error) => {
    console.error('Error previewing image:', error);
    this.toastr.error('Error loading image preview');
  };
  
  reader.readAsDataURL(file);
}
removeLogo(): void {
  console.log('Removing logo'); // للتأكد من تشغيل الدالة
  this.formData.main_image = null;
  this.previewUrl = null;
  
  // إعادة تعيين حقل الـ file input
  const fileInput = document.getElementById('logoUpload') as HTMLInputElement;
  if (fileInput) {
    fileInput.value = '';
  }
}

    
    cancel(): void {
      this.router.navigate(['/news']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }
 getInvestorsId(){ 
  this.apisService.investors().subscribe({
    next: (response: any) => {
      // The actual array is in response.data.data
      this.InvestorsId = response.data;  

     
      console.log("InvestorsId:", this.InvestorsId);
    },
    error: (error: any) => {
      console.log(error);
    }
  }
    
  )
 }

    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  const form = new FormData();

  // 📝 إرسال الحقول ثنائية اللغة
  form.append('title_ar', this.formData.title_ar?.trim());
  form.append('title_en', this.formData.title_en?.trim());
  form.append('content_ar', this.formData.content_ar?.trim());
  form.append('content_en', this.formData.content_en?.trim());

  // 🖼️ إرسال الصورة الرئيسية إذا وجدت
  if (this.formData.main_image instanceof File) {
    form.append('main_image', this.formData.main_image);
  }

  // 🖼️ إرسال الصور الإضافية
  if (this.formData.images && this.formData.images.length > 0) {
    this.formData.images.forEach((file: File, index: number) => {
      form.append(`images[${index}][path]`, file);
    });
  }

  this.apisService.addnews(form).subscribe({
    next: (response: any) => {
      this.toastr.success(this._translateService.instant('MENU.DASHBOARD.updated_successfully'));
      this.resetForm();
      this.router.navigate(['/news']);
    },
    error: (error: any) => {
      console.error('Error adding news:', error);
      if (error.error?.errors) {
        Object.keys(error.error.errors).forEach((key) => {
          this.toastr.error(error.error.errors[key][0]);
        });
      } else {
        this.toastr.error(this._translateService.instant('MENU.DASHBOARD.something_went_wrong'));
      }
    },
  });
}

// 🔄 دالة مساعدة لإعادة تعيين النموذج
resetForm() {
  this.formData = {
    title_ar: '',
    title_en: '',
    content_ar: '',
    content_en: '',
    main_image: null,
    images: null
  };
  this.previewUrl = null;
  this.imagePreviews = [];
  
  // إعادة تعيين حقول الملفات
  const fileInputs = document.querySelectorAll('input[type="file"]');
  fileInputs.forEach(input => (input as HTMLInputElement).value = '');
}


}